import clsx from "clsx";
import type { ComponentProps } from "react";

import { Image } from "@shared/ui/image";
import { Body } from "@shared/ui/typography";

import type { AuthorType } from "./model";

import s from "./author.module.scss";

export type AuthorProps = ComponentProps<"div"> & {
  className?: string;
  data: AuthorType;
};

export const Author = (props: AuthorProps) => {
  const {
    className,
    data: { name, position, photo },
  } = props;

  return (
    <div className={clsx(s.root, className)}>
      {photo?.url && (
        <Image
          className={s.photo}
          src={photo.url}
          alt={photo?.alternativeText ?? "author photo"}
        />
      )}
      <div className={s.info}>
        {name && <Body weight="semiBold">{name}</Body>}
        {position && <Body size="caption-small">{position}</Body>}
      </div>
    </div>
  );
};

Author.displayName = "Author";
